module.exports = __webpack_public_path__ + "Flag-70.2a39131011732e03f20435294624d8e9.svg";